import React, { useRef, useContext } from "react";
import paper from "../../assets/paper.png";
import pencil from "../../assets/pencil.png";
import trash from "../../assets/trash.png";
import moment from "moment/moment";
import message from "../../assets/message.png";
import printer from "../../assets/Printer.png";
import pdf from "../../assets/pdf.png";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { Grid } from "@mui/material";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { NumericFormat } from 'react-number-format';
import CurrencyFormat from "react-currency-format";
import LogicContext from "../../Context/LogicContext";
import { useForm } from "react-hook-form";

import AddNotificationTable from "./AddNotificationTable";
import NotificationType from "./NotificationType";
import AddNotificationScrol from "./AddNotificationScrol";
import { GetRecoilNotify, SetRecoilNotify } from "../../store/notificationMainAtom";
import { notificationService } from "../../services/notification.service";
import NotificationFilter from "./NotificationFilter";





const NotificationSendAddNew = () => {
  const setNotifyList = SetRecoilNotify();
  const getNotifyList = GetRecoilNotify();
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const navigate = useNavigate();
  const myPromiseModal = createModal(GeneralModal);
  const { register, setValue, getValues, handleSubmit, control, reset, formState: { errors } } = useForm();
  const logicContext = useContext(LogicContext);
  const [customerList, setCustomerList] = useState([]);





  useEffect(() => {
    // if (!getNotifyList.customers) {
    //   notificationService.getCustomerList().then(res => {
    //     if (res?.data?.length) {
    //       setNotifyList({ ...getNotifyList, customers: res?.data });
    //     }
    //   });
    // } else {
    //   setCustomerList(getNotifyList.customers);
    // }

  }, [getNotifyList?.customer, getNotifyList]);


  const setUserList = (ls) => {
    setSelectedUserIds(ls);
  }

  const onNotificationTypeSelect = async (sel) => {
    setValue("notification_type", sel?.Notification_Type_Id);

    try {
      const notiType = getValues();
      let response = await notificationService.notificationFilter({ option: notiType?.filter_option, notification_type: sel?.Notification_Type_Id });
      if (response?.data?.length > 0) {
        setNotifyList(prev => {
          return { ...prev, customers: response.data }
        });
        setCustomerList(response?.data);

      } else {
        setCustomerList([]);
      }

    } catch (error) {
      logicContext.showToast('Feature not available!');
    }
  }


  const onFilterSelect = async (selection) => {
    setValue("filter_option", selection?.filter_option);
    try {
      const notiType = getValues();
      let response = await notificationService.notificationFilter({ option: selection?.filter_option, notification_type: notiType?.notification_type });
      if (response?.data?.length > 0) {
        setNotifyList(prev => {
          return { ...prev, customers: response.data }
        });
        setCustomerList(response?.data);

      } else {
        setCustomerList([]);
      }

    } catch (error) {
      logicContext.showToast('Feature not available!');
    }

  }




  const onSubmit = async (schedule = false) => {
    const newData = getValues();
    

    console.log('Form data ', newData);
    console.log('schedule ', schedule);

    if (selectedUserIds.length < 1) {
      return logicContext.showToast("At least one user should be selected!", "error");
    }
    if (!newData?.notification_type) {
      return logicContext.showToast("Notification type is required!", "error");
    }

    if (newData?.message == "") {
      return logicContext.showToast("Notification message is required!", "error");
    }

    if (newData?.subject == "") {
      return logicContext.showToast("Notification subject is required!", "error");
    }




    await myPromiseModal({
      title: "Confirmation", body:schedule ? "Please select the date for the scedule notification":  "Do you want to send notification message?",
      showInput: false, placeHolder: '', showDate: schedule,
    }).then((res) => {
      console.log(res.date,'date...');
      if (res.decision === true) {

        if(!res.date && schedule === true){
          return logicContext.showToast("Please select the date for the scedule notification", 'error');
        }

        var xmlStringList = "";
        let subElement = ""
        selectedUserIds?.map((user_id) => {
          let temp = ` <a> <customer_id>${user_id} </customer_id></a>`;
          subElement += temp
        });
        xmlStringList += `<root> ${subElement}  </root>`


        let formToSubmit = { ...newData, xml_string: xmlStringList };
        if(schedule){
          formToSubmit = { ...newData, date_time:res.date, xml_string: xmlStringList };

        }
        if(formToSubmit?.notification_type === 1){
          // formToSubmit.message = `<p> ${formToSubmit.message.replace(/ /g,"<br/>") }</p>`  //"\\/"
          formToSubmit.message = `<p> ${formToSubmit.message.replace( "\\n","<br/>") }</p>`  //"\\/"
        }
        notificationService.sendNotificationMessage(formToSubmit).then((res) => {
          const cleanResponse =  logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
          sessionStorage.setItem("reloadPage", "true");
          navigate(-1);
          logicContext.showToast(cleanResponse?.message_text, 'success');


        });
      }
        
    })
      .catch((err) => {
        logicContext.showToast("error submitting record", "error");
      });
  };

  function formError(error) {
    logicContext.showToast("Form error", "error");
  }


  function onTemplateSelect(selection) {
    setValue("subject", selection?.Template_Name);
    setValue("message", selection?.Template_Message);
  }



  const onSearchKeyChange = (eve) => {
    const search = eve.target.value;

    if (search.length > 2 && getNotifyList.customers?.length) {
      let tempResult = getNotifyList.customers?.filter((customer) => {
        return customer?.customer_email_address?.toString()?.indexOf(search?.toLowerCase()) >= 0 ||
          customer?.customer_full_name?.toString().toLowerCase()?.indexOf(search?.toLowerCase()) >= 0 ||
          customer?.customer_id?.toString().toLowerCase()?.indexOf(search?.toLowerCase()) >= 0 ||
          customer?.customer_mobile_no?.toString().toLowerCase()?.indexOf(search?.toLowerCase()) >= 0
      });
      setCustomerList(tempResult);
    } else if (search.length < 1  && getNotifyList.customers?.length) {
      setCustomerList(getNotifyList.customers);
    }

  }



  return (
    <>
<section className="mt-6 px-4">
  {/* Top action buttons */}
  <div className="mt-4">
    <div className="flex justify-end space-x-3">
      <button className="px-3 h-[6vh] text-filterTextColor bg-filterColor rounded-lg lg:pt-1">
        <img src={paper} alt="paper icon" />
      </button>
      <button className="px-3 h-[6vh] text-filterTextColor bg-filterColor rounded-lg lg:pt-1">
        <img src={pdf} alt="pdf icon" />
      </button>
      <button className="px-3 h-[6vh] text-filterTextColor bg-filterColor rounded-lg lg:pt-1">
        <img src={printer} alt="printer icon" />
      </button>
      <button className="px-3 h-[6vh] text-filterTextColor bg-filterColor rounded-lg lg:pt-1">
        <img src={pencil} alt="pencil icon" />
      </button>
      <button className="px-3 h-[6vh] text-filterTextColor bg-filterColor rounded-lg lg:pt-1">
        <img src={trash} alt="trash icon" />
      </button>
    </div>
  </div>
  {/* Content section */}
  <div className="flex flex-col md:flex-row gap-6">
    {/* Left side */}
    <AddNotificationScrol
      onTemplateSelect={onTemplateSelect}
      list={getNotifyList.notification_template}
    />

    {/* Right side */}
    <div className="flex-1 max-w-6xl">
      <div className="bg-white shadow-md rounded-xl p-6 border border-gray-200">
        {/* Notification Type & Filter */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div>
            <label className=" text-sm font-medium text-gray-700 mb-2">
              Notification Type <span className="text-red-500">*</span>
            </label>
            <NotificationType
              onNotificationTypeSelect={onNotificationTypeSelect}
              list={getNotifyList.notification_type}
            />
          </div>
          <div>
            <label className=" text-sm font-medium text-gray-700 mb-2">
              Notification Filter <span className="text-red-500">*</span>
            </label>
            <NotificationFilter
              onFilterSelect={onFilterSelect}
              list={getNotifyList.notification_filter}
            />
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit(onSubmit, formError)}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div>
              <label className=" text-sm font-medium text-gray-700 mb-2">
                Notification Subject <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter subject"
                {...register("subject", {
                  required: "Subject message is required",
                })}
              />
            </div>
            <div>
              <label className=" text-sm font-medium text-gray-700 mb-2">
                Notification Message <span className="text-red-500">*</span>
              </label>
              <textarea
                className="w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 h-36 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter notification message"
                {...register("message", {
                  required: "Notification message is required",
                })}
              />
              <small className="text-red-500">
                {errors?.message && errors.message.message}
              </small>
            </div>
          </div>
        </form>

        {/* Customer list + search */}
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-4">
            <div className="font-semibold text-gray-700">
              <CurrencyFormat
                value={customerList?.length}
                displayType={"text"}
                thousandSeparator={true}
                suffix={" Customers"}
                renderText={(value) => <span>{value}</span>}
              />
            </div>
            <input
              onChange={(ev) => onSearchKeyChange(ev)}
              className="w-full md:w-64 rounded-lg border border-gray-300 bg-white px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              type="search"
              placeholder="Search (id, name, email)"
            />
          </div>

          <AddNotificationTable setUserList={setUserList} list={customerList} />
        </div>

        {/* Submit */}
        <div className="flex justify-end">
          <button
            onClick={() => onSubmit(true)}
            className="bg-yellow-500 text-white font-medium px-6 py-2.5 rounded-lg shadow-sm transition mr-4"
          >
            Schedule
          </button>
          <button
            onClick={() => onSubmit()}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-2.5 rounded-lg shadow-sm transition"
          >
            Send Now
          </button>
        </div>
      </div>
    </div>
  </div>
</section>


    </>
  );
};

export default NotificationSendAddNew;
